import React from 'react';
import { AddEntityWatcherButton } from '../../../watchers/components/add-entity-watcher/AddEntityWatcherButton';
import { LawFirmActions } from './LawFirmActions';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../components/modal/components/modal-restricted/withRestrictedModal';

const source = 'law_firm_page';

type Props = {
  isVisible: boolean;
  lawOfficeIdGroup: string;
  name: string;
} & WithRestrictedModalProps;

export function RawLawFirmActionSlider({
  isVisible,
  lawOfficeIdGroup,
  name,
  openRestrictedModal,
}: Props) {
  return (
    <div className="sub-header__rails__tunnel">
      <div className="sub-header__rails__mask" />
      <div
        className={
          isVisible
            ? 'sub-header__rails__slider'
            : 'sub-header__rails__slider__move'
        }
      >
        <div className="add-entity-watcher__page-slider">
          <AddEntityWatcherButton
            queryParams={{ oid: lawOfficeIdGroup, q: name }}
            uniqueId={lawOfficeIdGroup}
            restrict={() => openRestrictedModal('want_to_follow_law_firm')}
            source={source}
          />
        </div>

        <LawFirmActions name={name} source={source} />
      </div>
    </div>
  );
}

export const LawFirmActionSlider = withRestrictedModal(RawLawFirmActionSlider);
